import React from "react";
import FormControl from "@pency/components/form/FormControl";
import RadioGroup, {RadioRow} from "@pency/components/inputs/Radio";

import {RadioField} from "~/tenant/types";

interface Props {
  value: string;
  field: RadioField;
  onChange: (value: string) => void;
}

const RadioFieldInput: React.FC<Props> = ({value, field, onChange}) => {
  return (
    <FormControl isRequired={field.required} label={field.title} width="100%">
      <RadioGroup value={value} onChange={(event) => onChange(event.target.value)}>
        {field.text.map((option) => (
          <RadioRow key={option} value={option}>
            {option}
          </RadioRow>
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default RadioFieldInput;
